import React, { useState } from 'react';
import { View, StyleSheet} from 'react-native';
import { Text, TextType, useTheme } from '@suranceadmin/surance-ui-components';
import { isExtraSmallScreen } from '../../utils';
import { useIntl } from 'react-intl';
import { IphoneLogo, MainTopContainer, MainBottomContainer } from '../common/Main';

export const getMainText = () => {
    const intl = useIntl();
    const mainText = {
        title: intl.formatMessage({ id: 'bestCyberProtection' }),
        subTitle: intl.formatMessage({ id: 'downloadOurApp' }),
        belowIphoneLogo: intl.formatMessage({ id: 'stayOneStepAheadOfHackers' }),
        bottomText: intl.formatMessage({ id: 'yourSecretSuperPower' }),
    };
    return mainText;
}

const securityFeatures = [
    {
        description: 'innovativeTechnology',
    },
    {
        description: 'cyberExpertResponse',
    },
    {
        description: 'darkWebMonitoring',
    },
    {
        description: 'advancedPhishingDetection',
    },
];

export const DescriptionBelowIphoneLogo = ({ styles }) => {
    const theme = useTheme();
    const intl = useIntl();
    return (
        <View style={styles.verticalMargin}>
            {
                securityFeatures.map((item, index) => {
                    return (
                        <View key={index} style={styles.listContainer}>
                            <View style={styles.bullet}>
                                <Text style={{ color: theme.colors.text.ondark }}>{`\u2022`}</Text>
                            </View>
                            <Text
                                type={TextType.Body}
                                style={[styles.bulletText, { color: theme.colors.text.ondark }]}>
                                {intl.formatMessage(
                                    { id: item.description }
                                )}
                            </Text>
                        </View>
                    );
                })
            }
        </View>
    )
}

export const Main = () => {
    const theme = useTheme();
    const [layout, setLayout] = useState(0);
    const { styles } = useStyle(theme, layout);
    const { title, subTitle, belowIphoneLogo, bottomText } = getMainText();
    const onLayout = (event) => {
        const { height } = event.nativeEvent.layout;
        setLayout(height);
    }

    return (
        <View style={{ zIndex: 1, position: 'relative' }}>
            <MainTopContainer {...{ styles, onLayout, title, subTitle, belowIphoneLogo, bottomText }} />
            <MainBottomContainer {...{ styles, bottomText, DescriptionBelowIphoneLogo }} />

            <IphoneLogo styles={styles} />
        </View>
    )
}

const useStyle = (theme, layout) => {
    const styles = StyleSheet.create({
        listContainer: {
            marginTop: 2,
            paddingStart: 5,
            flexDirection: 'row',
        },
        bullet: {
            width: 5,
        },
        bulletText: {
            textAlign: 'left',
            writingDirection: 'auto',
            marginStart: 16,
            flex: 1,
        },
        verticalMargin: {
            marginVertical: 16,
        },
        topContainer: {
            paddingBottom: 100,
            backgroundColor: theme.colors.background.default,
            writingDirection: 'auto',
            paddingHorizontal: 24,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderWidth: 1,
            borderColor: theme.colors.background.default,
            position: 'relative',
            zIndex: 2,
            flex: 1
        },
        bottomContainer: {
            paddingLeft: 22,
            paddingRight: 22,
            writingDirection: 'auto',
        },
        title: {
            textAlign: theme.isRTL ? 'right' : 'left',
            color: theme.colors.background.header,
            marginTop: isExtraSmallScreen ? 28 : 32,
            writingDirection: 'auto',
        },
        subTitle: {
            marginTop: 8,
            textAlign: theme.isRTL ? 'right' : 'left',
            color: theme.colors.background.header,
            writingDirection: theme.isRTL ? 'rtl' : 'ltr',
        },
        button: {
            marginTop: 20,
        },
        image: {
            justifyContent: "center",
            paddingTop: 230,
        },
        imageBorderRadius: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        iphone: {
            width: 171,
            height: 360,
            position: 'absolute',
            top: layout - 100,
            zIndex: 8,
            alignSelf: 'center',
        },
        discount: {
            color: 'rgb(1 34 48)',
            fontWeight: 800,
            writingDirection: 'auto',
            textAlign: theme.isRTL ? 'right' : 'left',
            marginTop: 8,
            marginBottom: 10
        },
    });
    return { styles };
};


export default Main;
